import { Checkbox } from '@wyz/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { Trans } from '~/common/context';
import { IBrandTemplateForm } from '~/connect/types';
const STATES = {
  SELECTED: 'SELECTED',
  UNSELECTED: 'UNSELECTED',
  INDETERMINATE: 'INDETERMINATE',
} as const;
type States = (typeof STATES)[keyof typeof STATES];
export const DesadvGlobalCheckbox = ({
  onSelectAll,
  onDeselectAll,
}: {
  onSelectAll?: () => void;
  onDeselectAll?: () => void;
}) => {
  const methods = useFormContext<IBrandTemplateForm>();
  const watchedBrands = useWatch({
    control: methods.control,
    name: 'brands',
  });
  const enabledBrands = watchedBrands.filter((brand) => Boolean(brand.desadv));

  const state: States =
    enabledBrands.length === 0
      ? STATES.UNSELECTED
      : enabledBrands.length === watchedBrands.length
        ? STATES.SELECTED
        : STATES.INDETERMINATE;

  return (
    <Checkbox
      id={`desadvEnabled`}
      name={`desadv`}
      label={<Trans i18nKey='app.brand_template.form.desadv_enabled.label' />}
      onChange={() => {
        if (state === STATES.SELECTED) {
          onDeselectAll?.();
        } else {
          onSelectAll?.();
        }
      }}
      checked={state === STATES.SELECTED}
      indeterminate={state === STATES.INDETERMINATE}
    />
  );
};
